import { inject, observer, Provider } from 'mobx-react';
import React from 'react';
import { NavigateFunction } from 'react-router-dom';
import SemanticDatepicker from 'react-semantic-ui-datepickers';
import { Button, Confirm, Dropdown, Grid, Icon, Image, Input, Label, Message, Table } from 'semantic-ui-react';
import { CustomHeader } from '../../components/CustomHeader';
import withNavigation from '../../hocs/withNavigation';
import withParams from '../../hocs/withParams';
import { withPrompt } from '../../hocs/withPrompt';
import { Calibra } from '../../models/calibra';
import { CalibraService } from '../../services/calibra.service';
import { RootStore } from '../../stores/RootStore';
import { CalibraStore } from './CalibraStore';

interface IStores {
	CalibraStore: CalibraStore;
}

interface ICalibraDetailsPageProps {
	navigate?: NavigateFunction;
	RootStore?: RootStore;
	params?: any;
}

class CalibraDetailsPage extends React.Component<ICalibraDetailsPageProps> {
	stores: IStores;
	CalibraService: CalibraService;

	constructor(props: any) {
		super(props);

		this.stores = { CalibraStore: new CalibraStore(this.props.navigate, this.props.RootStore, this.props.params.id) };

		this.CalibraService = new CalibraService();
	}

	async componentDidMount() {
		if (this.props.params.id && this.props.params.id != '0') {
			this.stores.CalibraStore.calibraId = parseInt(this.props.params.id);
			await this.stores.CalibraStore.getCalibraById();
		} else {
			this.stores.CalibraStore.calibraItem = new Calibra();
			this.stores.CalibraStore.calibraItem.TechnicianRegistrationNumber = this.props.RootStore.currentUser.WawiCode;
			this.stores.CalibraStore.calibraItem.CalibrationTypeId = 1; 
			this.save(true);
		}
	}

	save(isNavigateNeeded: boolean) {
		this.stores.CalibraStore.saveCalibra(isNavigateNeeded);
		this.stores.CalibraStore.setEditMode(false);
	}

	public render() {
		const { CalibraStore } = this.stores;
		return (
			<div>
				<Provider {...this.stores}>
					<Confirm
						open={CalibraStore.isUploadConfirmOpen}
						closeOnEscape={false}
						closeOnDimmerClick={false}
						onConfirm={(event) => {
							CalibraStore.confirmUpload(event);
						}}
						onCancel={(event) => {
							CalibraStore.cancelUpload(event);
						}}
						cancelButton="Mégse"
						confirmButton={CalibraStore.file ? 'Feltöltés' : null}
						content={
							<div>
								<Label as="label" basic htmlFor="upload" style={{ padding: '50px 20px' }}>
									<Input
										hidden
										id={CalibraStore.uploadIdString}
										onChange={(event) => {
											CalibraStore.setFile(event);
										}}
										type="file"
										style={{ width: '718px' }}
									/>
								</Label>
								{CalibraStore.isFilePdf == false && (
									<div style={{ color: 'red', fontWeight: 'bold', paddingTop: 15, paddingLeft: 5 }}>A kiválasztott fájl formátumának PDF-nek kell lennie!</div>
								)}
							</div>
						}
					></Confirm>
					<Confirm
						open={CalibraStore.isLeavingPageConfirmOpen}
						closeOnEscape={false} //disables closing the window by pressing ESC
						closeOnDimmerClick={false} //disables closing the window by clicking outside of it
						onConfirm={() => {
							CalibraStore.confirmLeavingPage();
						}}
						onCancel={(event) => {
							CalibraStore.cancelLeaving(event);
						}}
						cancelButton="Nem"
						confirmButton="Igen"
						content={
							<div style={{ padding: 30 }}>
								<p>Biztosan elhagyod az oldalt? A nem mentett adatok elvesznek az oldal elhagyásával.</p>
							</div>
						}
					></Confirm>
					<div style={{ margin: 20, width: '95%' }}>
						<Grid>
							<Grid.Row centered>
								<Grid.Column width={12}>
									<Grid>
										<Grid.Row>
											<Grid.Column width={4}>
												<div>
													<label>Cikkszám</label>
													<span style={{ color: 'red', marginLeft: 2 }}>*</span>
												</div>
												<div style={{ display: 'flex' }}>
													{/* <Search placeholder='Keresés...' fluid className={(!CalibraStore.calibraItem?.ArticleNumberString && CalibraStore.isSaved) ? "searchError" : "search"}
													onResultSelect={(e, data) => { CalibraStore.updateCalibraPicker(data.result?.item) }}													
													onSearchChange={(event, data) => {
														//CalibraStore.calibraItem.ArticleNumber = null;
														CalibraStore.onChangeQueryText(event, data)
													}}
													results={CalibraStore.userByQueryTextDDL}
													value={CalibraStore.queryText || CalibraStore.calibraItem?.ArticleNumberString || ""} disabled={!CalibraStore.getEditMode || (CalibraStore.calibraItem?.StatusId == 100)}
													resultRenderer={(device) => {
														return <div style={{ color: "black" }}>{device.title} <Image style={{ maxHeight: '30px', maxWidth: 'fit-content' }} src={'https://assets.mmsrg.com/isr/166325/c1/-/' + device.item.PictureUrl}></Image></div>;
													}}
												/>											
												{CalibraStore.getEditMode && (
													<div style={{ marginLeft: 5, paddingTop: 3 }}>
														<Button color="red" compact onClick={() => CalibraStore.nullSelectedItemCalibra()}>X</Button>
													</div>
												)} */}
													<table style={{ width: '100%' }}>
														<tr>
															<td style={{ width: '200px' }}>
																<Input
																	fluid
																	value={CalibraStore.calibraItem.ArticleNumber}
																	onChange={(event, data) => {
																		CalibraStore.updateCalibraItem('ArticleNumber', data.value);
																	}}
																	disabled={!CalibraStore.getEditMode || CalibraStore.calibraItem?.StatusId == 100}
																	error={!!CalibraStore.getValidationsCalibration.ArticleNumber}
																/>
															</td>
															<td>
																{CalibraStore.getEditMode && CalibraStore.calibraItem?.StatusId != 100 && (
																	<Button
																		color="red"
																		onClick={() => {
																			CalibraStore.getCalibraDevices();
																		}}
																	>
																		Keresés
																	</Button>
																)}
															</td>
														</tr>
													</table>
												</div>
											</Grid.Column>
										</Grid.Row>
										<Grid.Row>
											<Grid.Column width={4}>
												<div>
													<label>Gyártó</label>
													<span style={{ color: 'red', marginLeft: 2 }}>*</span>
												</div>
												<Input
													fluid
													value={CalibraStore.calibraItem.Manufacturer}
													onChange={(event, data) => {
														CalibraStore.updateCalibraItem('Manufacturer', data.value);
													}}
													disabled={true}
													error={!!CalibraStore.getValidationsCalibration.Manufacturer}
												/>
											</Grid.Column>
											<Grid.Column width={4}>
												<div>
													<label>Gyártó feed</label>
													<span style={{ color: 'red', marginLeft: 2 }}>*</span>
												</div>
												<Dropdown
													selection
													fluid
													value={CalibraStore.calibraItem.ManufacturerId}
													onChange={(event, data) => {
														CalibraStore.updateCalibraItem('ManufacturerId', data.value);
													}}
													options={Object.values(this.stores?.CalibraStore?.manufacturerOptions ?? [])}
													disabled={!CalibraStore.getEditMode || CalibraStore.calibraItem?.StatusId == 100}
													error={!!CalibraStore.getValidationsCalibration.ManufacturerId}
												/>
											</Grid.Column>
											<Grid.Column width={4}>
												<div>
													<label>Típus</label>
													<span style={{ color: 'red', marginLeft: 2 }}>*</span>
												</div>
												<Input
													fluid
													value={CalibraStore.calibraItem.ProductType}
													onChange={(event, data) => {
														CalibraStore.updateCalibraItem('ProductType', data.value);
													}}
													disabled={true}
													error={!!CalibraStore.getValidationsCalibration.ProductType}
												/>
											</Grid.Column>
											<Grid.Column width={4}>
												<div>
													<label>Szériaszám</label>
													<span style={{ color: 'red', marginLeft: 2 }}>*</span>
												</div>
												<Input
													fluid
													value={CalibraStore.calibraItem.SerialNumber}
													onChange={(event, data) => {
														CalibraStore.updateCalibraItem('SerialNumber', data.value);
													}}
													disabled={!CalibraStore.getEditMode || CalibraStore.calibraItem?.StatusId == 100}
													error={!!CalibraStore.getValidationsCalibration.SerialNumber}
												/>
											</Grid.Column>
										</Grid.Row>

										<Grid.Row>
											<Grid.Column width={4}>
												<div>
													<label>Kalibrációt végző telephely</label>
													<span style={{ color: 'red', marginLeft: 2 }}>*</span>
												</div>
												{/* <Input fluid value={CalibraStore.calibraItem.CalibrationDepot}
												onChange={(event, data) => { CalibraStore.updateCalibraItem('CalibrationDepot', data.value) }}
												disabled={!CalibraStore.getEditMode} error={!!CalibraStore.getValidationsCalibration.CalibrationDepot}
												/> */}
												<Dropdown
													selection
													fluid
													value={CalibraStore.calibraItem.CalibrationDepot}
													options={this.props.RootStore.stores}
													disabled={!CalibraStore.getEditMode}
													error={!!CalibraStore.getValidationsCalibration.CalibrationDepot}
													onChange={(e, data) => {
														CalibraStore.updateCalibraItem('CalibrationDepot', data.value);
													}}
												/>
											</Grid.Column>
											<Grid.Column width={4}>
												<div>
													<label>Technikus törzsszáma</label>
													<span style={{ color: 'red', marginLeft: 2 }}>*</span>
												</div>
												<Input
													fluid
													type="number"
													value={CalibraStore.calibraItem.TechnicianRegistrationNumber}
													onChange={(event, data) => {
														CalibraStore.updateCalibraItem('TechnicianRegistrationNumber', data.value);
													}}
													disabled={true}
													error={!!CalibraStore.getValidationsCalibration.TechnicianRegistrationNumber}
												/>
											</Grid.Column>
											<Grid.Column width={4}>
												<div>
													<label>Kalibráció dátuma</label>
													<span style={{ color: 'red', marginLeft: 2 }}>*</span>
												</div>
												<SemanticDatepicker
													firstDayOfWeek={1}
													value={CalibraStore.calibraItem.CalibrationDateUtc ? new Date(CalibraStore.calibraItem.CalibrationDateUtc) : null}
													onChange={(event, data) => {
														CalibraStore.updateCalibraItem('CalibrationDateUtc', data.value);
													}}
													maxDate={new Date()}
													disabled={!CalibraStore.getEditMode}
													error={!!CalibraStore.getValidationsCalibration.CalibrationDateUtc}
												/>
											</Grid.Column>
											<Grid.Column width={4}>
												<div>
													<label>Kalibráció típusa</label>
													<span style={{ color: 'red', marginLeft: 2 }}>*</span>
												</div>
												<Dropdown
													selection
													fluid
													value={CalibraStore.calibraItem.CalibrationTypeId}
													onChange={(event, data) => {
														CalibraStore.updateCalibraItem('CalibrationTypeId', data.value);
													}}
													options={Object.values(this.stores?.CalibraStore?.calibrationTypes ?? [])}
													disabled={!CalibraStore.getEditMode}
													error={!!CalibraStore.getValidationsCalibration.CalibrationTypeId}
												/>
											</Grid.Column>
										</Grid.Row>
									</Grid>
								</Grid.Column>
							</Grid.Row>
							{CalibraStore.calibraItem?.StatusId == 100 && (
								<Grid.Row>
									<Grid.Column width={2}></Grid.Column>
									<Grid.Column width={5}>
										<CustomHeader>QR kód</CustomHeader>
										<Image src={`data:image/png;base64,${CalibraStore.calibraItem?.QRCode}`} />
									</Grid.Column>
								</Grid.Row>
							)}
							<Grid.Row>
								<Grid.Column width={2}></Grid.Column>
								<Grid.Column width={12}>
									<CustomHeader>Dokumentumok</CustomHeader>
									<Table>
										<Table.Header>
											<Table.Row>
												<Table.HeaderCell>Fájl név</Table.HeaderCell>
												<Table.HeaderCell>Feltöltő</Table.HeaderCell>
												<Table.HeaderCell>Feltöltés dátuma</Table.HeaderCell>
												<Table.HeaderCell>Eltávolítás</Table.HeaderCell>
											</Table.Row>
										</Table.Header>
										<Table.Body>
											{CalibraStore.calibraDocuments?.map((item, index) => {
												return (
													<Table.Row key={index}>
														<Table.Cell>
															<a style={{ cursor: 'pointer' }} onClick={() => CalibraStore.getCalibrationDocumentById(item.Id)} download>
																{item.FileName}
															</a>
														</Table.Cell>
														<Table.Cell>{item.UploadedByName}</Table.Cell>
														<Table.Cell>{item.UploadedDateUtcString}</Table.Cell>
														<Table.Cell
															onClick={() => {
																CalibraStore.deleteCalibrationDocumentById(item.Id);
															}}
														>
															{CalibraStore.getEditMode && item.TypeId == 2 ? <Icon name="trash" style={{ cursor: 'pointer', color: '#df0000' }} /> : null}
														</Table.Cell>
													</Table.Row>
												);
											})}
										</Table.Body>
									</Table>
								</Grid.Column>
							</Grid.Row>
							<Grid.Row>
								<Grid.Column width={2}></Grid.Column>
								<Grid.Column width={2}>
									{(this.props.RootStore.currentUser.IsHQCalibrator || this.props.RootStore.currentUser.IsStoreCalibrator) && (
										<Button
											color="green"
											onClick={() => {
												CalibraStore.setIsUploadConfirmOpen();
											}}
											disabled={CalibraStore.calibraItem?.StatusId == 100 && CalibraStore.editMode == false}
										>
											Feltöltés
										</Button>
									)}
								</Grid.Column>
							</Grid.Row>
							<Grid.Row>
								<Grid.Column width={2}></Grid.Column>
								<Grid.Column width={12}>
									<CustomHeader>Napló</CustomHeader>
									<Table>
										<Table.Header>
											<Table.Row>
												<Table.HeaderCell>Felhasználó</Table.HeaderCell>
												<Table.HeaderCell>Időpont</Table.HeaderCell>
												<Table.HeaderCell>Művelet</Table.HeaderCell>
											</Table.Row>
										</Table.Header>
										<Table.Body>
											{CalibraStore.calibraHistories?.map((item, index) => {
												return (
													<Table.Row key={index}>
														<Table.Cell>{item.CreatedByName}</Table.Cell>
														<Table.Cell>{item.CreatedDateUtcString}</Table.Cell>
														<Table.Cell>{item.LogType}</Table.Cell>
													</Table.Row>
												);
											})}
										</Table.Body>
									</Table>
								</Grid.Column>
							</Grid.Row>
							<Grid.Row>
								<Grid.Column width={2}></Grid.Column>
								<Grid.Column width={3} style={{ textAlign: 'left' }}>
									<Button
										onClick={() => {
											CalibraStore.setIsLeavingPageConfirmOpen();
										}}
									>
										Mégse
									</Button>
								</Grid.Column>
								<Grid.Column width={3} style={{ textAlign: 'left' }}>
									{CalibraStore.calibraItem?.StatusId > 0 && (
										<Button
											color="blue"
											onClick={() => {
												CalibraStore.downloadCustomerInformation(CalibraStore.calibraItem?.Id);
											}}
										>
											{/* Vásárlói tájékoztató */}
											Dokumentáció letöltése
										</Button>
									)}
								</Grid.Column>
								<Grid.Column width={3} style={{ textAlign: 'right' }}>
									{CalibraStore.calibraItem.IsDeleted == false && (this.props.RootStore.currentUser.IsHQCalibrator || this.props.RootStore.currentUser.IsStoreCalibrator) && (
										<Button
											color="red"
											onClick={() => {
												CalibraStore.deleteCalibra();
											}}
										>
											Törlés
										</Button>
									)}
								</Grid.Column>
								<Grid.Column width={3} style={{ textAlign: 'right' }}>
									{CalibraStore.calibraItem.IsDeleted == false && (this.props.RootStore.currentUser.IsHQCalibrator || this.props.RootStore.currentUser.IsStoreCalibrator) && (
										<React.Fragment>
											{CalibraStore.calibraItem.StatusId == 0 || CalibraStore.editMode == true ? (
												<Button
													color="green"
													onClick={() => {
														this.save(false);
													}}
												>
													Rögzítés
												</Button>
											) : (this.props.RootStore.currentUser.IsHQCalibrator &&
												<Button
													color="yellow"
													onClick={() => {
														CalibraStore.setEditMode(true);
													}}
												>
													Módosítás
												</Button>
											)}
										</React.Fragment>
									)}
								</Grid.Column>
								<Grid.Column width={2}></Grid.Column>
							</Grid.Row>
						</Grid>
						<Confirm
							open={CalibraStore.showValidationErrorPopup && CalibraStore.hasValidationErrors}
							closeOnEscape={false} //disables closing the window by pressing ESC
							closeOnDimmerClick={false} //disables closing the window by clicking outside of it
							onCancel={() => {
								CalibraStore.cancelShowValidationErrorPopup();
							}}
							cancelButton="Bezár"
							confirmButton={false}
							content={
								<div style={{ padding: 40 }}>
									<Message style={{ maxHeight: 300, overflow: 'auto' }} negative>
										<Message.Header>Hiba a mentés közben!</Message.Header>
										<span>
											Validációs hibák:
											<ul style={{ marginLeft: 18 }}>
												{Object.values(CalibraStore.getValidationsCalibration).map((error) => {
													return <li key={error}>{error}</li>;
												})}
											</ul>
										</span>
									</Message>
								</div>
							}
						></Confirm>
						<Confirm
							open={CalibraStore.isSerialNumberEmptyOpen}
							closeOnEscape={false} //disables closing the window by pressing ESC
							closeOnDimmerClick={false} //disables closing the window by clicking outside of it
							onCancel={() => {
								CalibraStore.cancelSerialNumberEmptyOpen();
							}}
							cancelButton="Bezár"
							confirmButton={false}
							content={
								<div style={{ padding: 40 }}>
									<Message style={{ maxHeight: 300, overflow: 'auto' }} negative>
										{/* <Message.Header>Hiba a mentés közben!</Message.Header> */}
										<span>
											<ul style={{ marginLeft: 18 }}>
												<li>Szériaszám megadása kötelező!</li>
											</ul>
										</span>
									</Message>
								</div>
							}
						></Confirm>
					</div>
				</Provider>
			</div>
		);
	}
}

export default withParams(withNavigation(inject('RootStore')(observer(CalibraDetailsPage))));
